import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: theme.shadows[4],
        zIndex: theme.zIndex.appBar,
    },
    errorHeader: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        ...theme.mixins.flex.alignItemsCenter,

        '& span': {
            fontWeight: 'bold',
            paddingLeft: 10,
        },
    },
    errorStack: {},
}));

export default useStyles;
